import axios from 'axios';

export const lunchTicketApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/lunch-tickets`,
    headers: {
        'Content-Type': 'application/json'
    }
})